import { render, staticRenderFns } from "./RollActivity.vue?vue&type=template&id=67cae2d8&"
import script from "./RollActivity.vue?vue&type=script&lang=js&"
export * from "./RollActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports